import { RefreshIcon } from "@mgdx/ui/components/Icon";
import React from "react";

import * as styles from "./CircularProgress.module.css";

const CircularProgress = ({ ...props }) => <RefreshIcon className={styles.circularProgress} {...props} />;

export default CircularProgress;
